import { render, staticRenderFns } from "./WhatsappTutorial.vue?vue&type=template&id=72b3310c&scoped=true"
import script from "./WhatsappTutorial.vue?vue&type=script&lang=js"
export * from "./WhatsappTutorial.vue?vue&type=script&lang=js"
import style0 from "./WhatsappTutorial.vue?vue&type=style&index=0&id=72b3310c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b3310c",
  null
  
)

export default component.exports